import { createStore } from 'satcheljs';
import { IWindowSize } from '../index.types';

export const getStore = createStore<IWindowSize>('WindowSize', {
  width: window?.innerWidth,
  height: window?.innerHeight,
});
